import React from 'react';

export default function PrivacyPolicy() {
  return (
    <main className="privacy-policy" style={{ padding: '2rem', maxWidth: 900, margin: '0 auto' }}>
      <h1>Politique de confidentialité – Ankataa</h1>
      <p><strong>Dernière mise à jour :</strong> 10/08/2025</p>

      {/* Bloc obligatoire Google Play */}
      <p><strong>Nom de l’application :</strong> Ankataa</p>
      <p><strong>Éditeur / Développeur :</strong> Ankataa SARL</p>
      <p><strong>Email :</strong> ankataa.ml@gmail.com</p>
      <p><strong>Téléphone :</strong> +22370337101</p>
      <p><strong>Adresse :</strong> MISSABOUGOU </p>

      <p>
        La présente politique de confidentialité décrit comment Ankataa (ci-après « nous », « notre », « nos ») collecte,
        utilise, partage et protège les informations personnelles des utilisateurs de ses applications :
      </p>
      <ul>
        <li>Ankataa (clients/passagers)</li>
        <li>Ankataa Driver (chauffeurs)</li>
        <li>Ankataa Marchand (commerçants et partenaires)</li>
      </ul>
      <p>
        Nous nous engageons à protéger vos données et à respecter les lois applicables en matière de protection de la vie privée.
      </p>

      <h2>1. Données collectées</h2>
      <p>Nous collectons différentes catégories de données, selon l’application utilisée :</p>

      <h3>1.1. Utilisateurs (clients/passagers)</h3>
      <ul>
        <li>Coordonnées : nom, prénom, numéro de téléphone, adresse e-mail.</li>
        <li>Données de localisation : pour rechercher un chauffeur et suivre votre trajet en temps réel.</li>
        <li>Informations de paiement : carte bancaire, portefeuille mobile, ou confirmation de paiement en espèces.</li>
        <li>Historique des trajets et préférences de réservation.</li>
      </ul>

      <h3>1.2. Chauffeurs (Ankataa Driver)</h3>
      <ul>
        <li>Informations personnelles : nom, prénom, numéro de téléphone, e-mail.</li>
        <li>Données professionnelles : permis de conduire, immatriculation du véhicule, assurance.</li>
        <li>Données de localisation en temps réel pour l’assignation des courses.</li>
        <li>Historique des courses et revenus.</li>
      </ul>

      <h3>1.3. Marchands (Ankataa Marchand)</h3>
      <ul>
        <li>Coordonnées de l’entreprise : nom, adresse, numéro de téléphone, e-mail.</li>
        <li>Données de facturation et paiements.</li>
        <li>Informations sur les commandes et livraisons.</li>
        <li>Localisation pour l’envoi et la réception des colis.</li>
      </ul>

      <h2>2. Utilisation des données</h2>
      <p>Vos données sont utilisées pour :</p>
      <ul>
        <li>Fournir et améliorer nos services.</li>
        <li>Personnaliser votre expérience.</li>
        <li>Gérer les comptes.</li>
        <li>Traiter les paiements.</li>
        <li>Assurer la sécurité.</li>
        <li>Communiquer avec vous.</li>
      </ul>

      <h2>3. Partage des données</h2>
      <p>Vos informations peuvent être partagées uniquement dans les cas suivants :</p>
      <ul>
        <li>Avec les chauffeurs.</li>
        <li>Avec les partenaires de paiement.</li>
        <li>Avec les prestataires techniques.</li>
        <li>Avec les autorités, si requis par la loi.</li>
      </ul>
      <p>Nous ne vendons jamais vos données personnelles.</p>

      <h2>4. Sécurité des données</h2>
      <p>Nous mettons en œuvre des mesures pour protéger vos données contre :</p>
      <ul>
        <li>L’accès non autorisé.</li>
        <li>La perte ou l’altération.</li>
        <li>La fraude.</li>
      </ul>

      <h2>5. Vos droits</h2>
      <p>Conformément à la loi, vous disposez des droits suivants :</p>
      <ul>
        <li>Droit d’accès</li>
        <li>Droit de rectification</li>
        <li>Droit de suppression</li>
        <li>Droit d’opposition</li>
      </ul>
      <p>Contact : ankataa.ml@gmail.com</p>

      <h2>6. Conservation des données</h2>
      <p>
        Vos données sont conservées aussi longtemps que nécessaire pour fournir nos services et respecter nos obligations légales.
      </p>

      <h2>7. Confidentialité des applications</h2>
      <p>
        Nos applications respectent strictement les pratiques décrites dans cette politique.
      </p>

      <h2>8. Modifications</h2>
      <p>
        Nous pouvons mettre à jour cette politique à tout moment. Les modifications seront notifiées dans l’application.
      </p>

      <h2>9. Contact</h2>
      <p>
        📧 Email : ankataa.ml@gmail.com<br />
        📍 Téléphone : +22370337101
      </p>
    </main>
  );
}
